import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

export type TenantSettingsData = {
  dateFormat?: string;
  timeFormat?: string;
  timeZone?: string;
};

type TenantSettingsStore = TenantSettingsData & {
  updateTenantSettings: (data: TenantSettingsData) => void;
};

export const useTenantSettingsStore = create<TenantSettingsStore>()(
  immer((set) => ({
    dateFormat: undefined,
    timeFormat: undefined,
    timeZone: undefined,
    updateTenantSettings(data) {
      set((state) => {
        if (data.dateFormat != null) state.dateFormat = data.dateFormat;
        if (data.timeFormat != null) state.timeFormat = data.timeFormat;
        if (data.timeZone != null) state.timeZone = data.timeZone;
      });
    },
  })),
);
